import { getClickQuadrant } from "../../../../library";
export function calculateListPosition(buttonElement, listElement) {
    var buttonRect = buttonElement.getBoundingClientRect();
    var listRect = listElement.getBoundingClientRect();
    var quadrant = getClickQuadrant({ clientX: buttonRect.x, clientY: buttonRect.y });
    if (quadrant.x === 'right') {
        listElement.style.left = "".concat(buttonRect.left - (listRect.width - buttonRect.width), "px");
        listElement.style.right = "auto";
    }
    if (quadrant.x === 'left') {
        listElement.style.left = "".concat(buttonRect.left, "px");
        listElement.style.right = "auto";
    }
    if (quadrant.y === 'top') {
        listElement.style.top = "".concat(buttonRect.top + buttonRect.height, "px");
        listElement.style.bottom = "auto";
    }
    if (quadrant.y === 'bottom') {
        listElement.style.top = "".concat(buttonRect.top - listRect.height, "px");
        listElement.style.bottom = "auto";
    }
    return quadrant.y;
}
